const tools = [
  {
    id: 1,
    name: 'Title',
    type: 'txt-title',
    description: 'Bloc Titre',
    form: [
      { type: 'text', name: 'title_top', value: '' },
      { type: 'text', name: 'title_bottom', value: '' }
    ]
  },
  {
    id: 2,
    name: 'Text only',
    type: 'txt-only',
    description: 'Bloc Texte',
    form: [{ type: 'text', name: 'text', value: '' }]
  },
  {
    id: 3,
    name: 'Image only',
    type: 'img-only',
    description: 'Image',
    form: [
      { type: 'image', name: 'img_url', value: '' },
      { type: 'text', name: 'link_url', value: '' }
    ]
  },
  {
    id: 4,
    name: 'Product',
    type: 'prd',
    description: 'Produit',
    form: [
      { type: 'text', name: 'title', value: '' },
      { type: 'text', name: 'description', value: '' },
      { type: 'number', name: 'price', value: '' },
      { type: 'number', name: 'discounted_price', value: '' },
      { type: 'number', name: 'ecopart', value: '' },
      { type: 'image', name: 'img_url', value: '' },
      { type: 'text', name: 'link_url', value: '' },
      { type: 'text', name: 'btn_label', value: '' }
    ]
  },
  {
    id: 5,
    name: '2 Products',
    type: 'prdx2',
    description: '2 produits côte à côte',
    form: [
      { type: 'text', name: 'title1', value: '' },
      { type: 'text', name: 'description1', value: '' },
      { type: 'number', name: 'price1', value: '' },
      { type: 'number', name: 'discounted_price1', value: '' },
      { type: 'number', name: 'ecopart1', value: '' },
      { type: 'image', name: 'img_url1', value: '' },
      { type: 'text', name: 'link_url1', value: '' },
      { type: 'text', name: 'title2', value: '' },
      { type: 'text', name: 'description2', value: '' },
      { type: 'number', name: 'price2', value: '' },
      { type: 'number', name: 'discounted_price2', value: '' },
      { type: 'number', name: 'ecopart2', value: '' },
      { type: 'image', name: 'img_url2', value: '' },
      { type: 'text', name: 'link_url2', value: '' },
      { type: 'text', name: 'btn_label', value: '' }
    ]
  },
  {
    id: 6,
    name: 'Product + Image',
    type: 'prdimg',
    description: 'Produit + Image à droite',
    form: [
      { type: 'text', name: 'title', value: '' },
      { type: 'text', name: 'description', value: '' },
      { type: 'number', name: 'price', value: '' },
      { type: 'number', name: 'discounted_price', value: '' },
      { type: 'number', name: 'ecopart', value: '' },
      { type: 'image', name: 'img_url', value: '' },
      { type: 'text', name: 'link_url', value: '' },
      { type: 'image', name: 'img_url2', value: '' },
      { type: 'text', name: 'btn_label', value: '' }
    ]
  },
  {
    id: 7,
    name: 'Image + Product',
    type: 'imgprd',
    description: 'Produit + Image à gauche',
    form: [
      { type: 'image', name: 'img_url2', value: '' },
      { type: 'text', name: 'title', value: '' },
      { type: 'text', name: 'description', value: '' },
      { type: 'number', name: 'price', value: '' },
      { type: 'number', name: 'discounted_price', value: '' },
      { type: 'number', name: 'ecopart', value: '' },
      { type: 'image', name: 'img_url', value: '' },
      { type: 'text', name: 'link_url', value: '' },
      { type: 'text', name: 'btn_label', value: '' }
    ]
  },
  {
    id: 8,
    name: 'Video',
    type: 'video',
    description: 'Video from youtube',
    form: [
      { type: 'text', name: 'video_id', value: '' }
    ]
  },
  {
    id: 9,
    name: 'Slider',
    type: 'slider',
    description: 'Slider with images',
    form: [
      { type: 'image', name: 'slider_img_1', value: '' },
      { type: 'text', name: 'link_url1', value: '' },
      { type: 'image', name: 'slider_img_2', value: '' },
      { type: 'text', name: 'link_url2', value: '' },
      { type: 'image', name: 'slider_img_3', value: '' },
      { type: 'text', name: 'link_url3', value: '' },
      { type: 'image', name: 'slider_img_4', value: '' },
      { type: 'text', name: 'link_url4', value: '' },
      { type: 'image', name: 'slider_img_5', value: '' },
      { type: 'text', name: 'link_url5', value: '' },
    ]
  },
  // {
  //   id: 10,
  //   name: 'Category',
  //   type: 'cat-multi',
  //   description: 'Display other categories (frames) max 4',
  //   form: [
  //     { type: 'text', name: 'title', value: '' },
  //     { type: 'number', name: 'max', value: '' }
  //   ]
  // },
  {
    id: 11,
    name: 'Category (single)',
    type: 'cat-single',
    description: 'Display other categories (landscapes) max 4',
    form: [
      { type: 'text', name: 'btn_label', value: '' },
      { type: 'number', name: 'max', value: '' }
    ]
  },
]

export const Tools = tools
export default Tools